/** Optional analysis identities/configuration shared by execution admission and saved-result reads.
 * Source declarations name existing enforcement owners; they are not a new executor or proof of purity.
 * No capability requires another optional analysis to succeed.
 */
import * as z from 'zod';
export const studyAnalysisDefinitions = {
    'response-phrases': {
        enabled: true,
        sourceScope: 'accepted-comparison',
        requiredInputs: ['accepted-parent-run', 'complete-cross-version-exchanges'],
        sourceOwner: 'response-phrase-preview.prepareResponsePhrases',
        executionOwner: 'study.effect.extract_response_phrases → StudyAction.extract_response_phrases',
    },
    'classify-purchase-decision-responses': {
        enabled: true,
        sourceScope: 'accepted-version',
        requiredInputs: ['accepted-run-observation', 'eligible-saved-answers'],
        sourceOwner: 'study-run-effects/classify-purchase-decision-responses',
        executionOwner: 'study.effect.classify_purchase_decision_responses',
    },
    'synthetic-inquiry': {
        enabled: true,
        sourceScope: 'accepted-version',
        requiredInputs: ['source-child-run', 'complete-original-exchange'],
        sourceOwner: 'synthetic-inquiry-run-sources',
        executionOwner: 'StudyAction.run_synthetic_inquiry',
    },
};
const nodeIds = Object.keys(studyAnalysisDefinitions);
const switches = Object.fromEntries(nodeIds.map((node) => [node, z.boolean()]));
export const studyAnalysisConfigSchema = z.object(switches).strict();
export const defaultStudyAnalysisConfig = studyAnalysisConfigSchema.parse(Object.fromEntries(nodeIds.map((node) => [node, studyAnalysisDefinitions[node].enabled])));
export const studyAnalysisOutcomeSchema = z.object({
    node: z.enum(nodeIds),
    status: z.enum([
        'available',
        'partial',
        'queued',
        'running',
        'disabled',
        'unavailable',
        'empty',
        'failed',
        'uncertain',
    ]),
    reason: z.string().nullable(),
});
//# sourceMappingURL=study-analysis.js.map